import { render, staticRenderFns } from "./ReceptionTransfer.vue?vue&type=template&id=bdee7370&scoped=true&"
import script from "./ReceptionTransfer.vue?vue&type=script&lang=js&"
export * from "./ReceptionTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionTransfer.vue?vue&type=style&index=0&id=bdee7370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdee7370",
  null
  
)

export default component.exports